// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"U5-z","colorTextValue":"V5-z","swatches":"W5-z","collapseLink":"X5-z","isCollapsed":"Y5-z","dropdown":"Z5-z","disabled":"_5-z"};